import { fromJS,List, Map, Set } from "immutable";
import _ from "lodash";

let createFromJS = {};

createFromJS.registerCallback = (name, fn) => {
  createFromJS[name] = fn;
};

// Used for immutable types that contain only primitive values (ints, strings, bools)
createFromJS.createPrimitiveCallback = ImmutableType => any => new ImmutableType(any);

// Used for immutable types that contain nested objects or types that require conversion.
// The data object is broken into the following sections:
//   - Objects are converted directly into the given ChildType
//
//     objects: {
//       key1: ChildType,
//       key2: ChildType,
//     },
//
//   - Collections are converted into Lists or Maps of objects of a given ChildType
//
//     collections: {
//       key1: ChildType,
//       key2: ChildType,
//     },
//
//   - ID Lists are converted into an IdReferenceList, which has a map of ChildType objects
//     under byId, and a List of the object ids under allIds
//
//     idLists: {
//       key1: ChildType,
//       key2: ChildType,
//     }
//
//   - IDByTypeLists are converted into an IdByTypeReferenceList, which has a
//     map of ChildType objects under byId, a List of the object ids under allIds, and a
//     separate list of idsByType
//
//     idByTypeLists: {
//       key1: ChildType,
//       key2: ChildType,
//     }

const nestedDataOptions = {
  objects: {},
  collections: {},
  idLists: {},
  idByTypeLists: {}
};

/**
 * Note: creating a record by createFromJS
 * will merge in the properties of the provided js object.
 * When a property is missing or undefined, the initial value of
 * that will be the default value. (undefined => default value, null => null)
 * Eg. ARecord = Record({a: "xyz", b: 123, c: BRecord(), d: CRecord() })
 * createFromJs.ARecord({ a: "uvw", c: null, d: {...} }) = Record({a: "uvw", b: 123, c: null,  d: Record({...} )})
 */
createFromJS.createNestedCallback = (ImmutableType, inData) => {
  const data = _.merge({}, nestedDataOptions, inData);
  return any => {
    return new ImmutableType(fromJS(any)).withMutations(o => {
      _.each(data.collections, (subTypeName, subName) => {
        // console.log(
        //   `iterating data.collections for subName = ${subName}. Will call createFromJS[${subTypeName}]... createFromJS[subTypeName] exists = ${Boolean(
        //     createFromJS[subTypeName]
        //   )}`
        // );
        o.update(subName, val => {
          return _.isNil(val) ? val : val.map(createFromJS[subTypeName]);
        });
      });
      _.each(data.objects, (subTypeName, subName) => {
        // console.log(
        //   `iterating data.objects for subName = ${subName}. Will call createFromJS[${subTypeName}]... createFromJS[subTypeName] exists = ${Boolean(
        //     createFromJS[subTypeName]
        //   )}`
        // );
        o.update(subName, val => {
          return _.isNil(val) ? val : createFromJS[subTypeName](val);
        });
      });
      _.each(data.idLists, (subTypeName, subName) => {
        // console.log(
        //   `iterating data.idLists for subName = ${subName}. Will call createFromJS[${subTypeName}]... createFromJS[subTypeName] exists = ${Boolean(
        //     createFromJS[subTypeName]
        //   )}`
        // );
        o.update(subName, val => createFromJS.IdReferenceList(subTypeName, val));
      });
      _.each(data.idByTypeLists, (subTypeName, subName) => {
        // console.log(
        //   `iterating data.idByTypeLists for subName = ${subName}. Will call createFromJS[${subTypeName}]... createFromJS[subTypeName] exists = ${Boolean(
        //     createFromJS[subTypeName]
        //   )}`
        // );
        o.update(subName, val => createFromJS.IdByTypeReferenceList(subTypeName, val));
      });
    });
  };
};

// Our own creators for standard immutable types
// Basic "fromJS" constructors for list and map...
createFromJS.Map = any => Map(any);
createFromJS.List = any => List(any);
createFromJS.Set = any => Set(any);

export default createFromJS;
